import TypePerturbationActions from '../../../../actions/type-perturbation.actions';

import clone from 'lodash/clone';
import assign from 'lodash/assign';
import some from 'lodash/some';
import find from 'lodash/find';

require('./type-perturbation.scss');

export default class TypePerturbationComponent {
  constructor() {
    this.controller = TypePerturbationController;
    this.template = require('./type-perturbation.html');
    this.bindings = {
      typePerturbation: '<',
      origine: '@',
      parentForm: '<',
      onTypePerturbationChange: '&'
    };
  }
}

// @ngInject
class TypePerturbationController {
  constructor($scope, $ngRedux) {
    this.$scope = $scope;
    this.$ngRedux = $ngRedux;

    this.data = {};
    this.typesPerturbation = {};
  }

  $onInit() {
    this.$ngRedux.dispatch(TypePerturbationActions.loadData());
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          typesPerturbation: state.typePerturbation,
        };
      }
    )((selectedState) => {
      assign(this, selectedState);
      this.validateTypePerturbation();
    });

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);

  }

  validateTypePerturbation() {
    if (!this.typePerturbation || this.typesPerturbation.fetching || !this.typesPerturbation.data) {
      return;
    }
    // Vérifier que la valeur est bien dans la liste
    if (some(this.typesPerturbation.data, t => t.id === this.typePerturbation.id)) {
      this.data.typePerturbation = clone(this.typePerturbation);
    }
  }

  onChange(typePerturbation) {
    this.onTypePerturbationChange({typePerturbation: find(this.typesPerturbation.data, {'id': typePerturbation})});
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/type-perturbation/type-perturbation.component.js